import React, { ReactNode } from 'react'
import '@stretto/cds-tokens/lib/css/base.css'
import './styles.scss'

interface ChipProps {
  isDismissable?: boolean
  variant: 'primary' | 'secondary'
  onRemove?: () => void
  disabled?: boolean
  className?: string
  children: ReactNode
}

const Chip = ({
  isDismissable,
  variant = 'primary',
  onRemove,
  disabled,
  className,
  children
}: ChipProps): JSX.Element => {
  const baseClass = [className, 'chip', variant, disabled ? 'is-disabled' : '']
    .filter(Boolean)
    .join(' ')

  return (
    <span className={baseClass}>
      {children}
      {isDismissable && <button onClick={onRemove}>+</button>}
    </span>
  )
}

export default Chip
